import { useEffect, useRef, useState } from "react";
import { AngleDownIcon } from "../../../icons";
import { useModal } from "../../../hooks/useModal";
import MuiModel from "../../Mui/model/MuiModel";
import MuiModelBox from "../../Mui/model/MuiModelBox";
import MapRoute from "../../googleMap/googleMap";
import { decryptObject } from "../../../utils/crypt";
import { useSearchParams } from "react-router";

const Stop = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const { isOpen, openModal, closeModal } = useModal();
  const [formAction, setFormAction] = useState("");
  const [popFormId, setPopFormId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [isSection, setIsSection] = useState(false);
  const [searchParams] = useSearchParams();
  const [sourceData, setSourceData] = useState("");

  useEffect(() => {
    const encryptedId = searchParams.get("id");
    if (encryptedId) {
      // Only attempt decryption if 'id' parameter exists
      const decrypted = decryptObject(encryptedId);
      setSourceData(decrypted);
    } else {
    }
  }, [searchParams]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div className="relative inline-block text-left" ref={dropdownRef}>
        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-1 bg-indigo-500 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none"
        >
          Stops{" "}
          <AngleDownIcon
            width={12}
            height={12}
            className={`mt-1 ml-1 ${open ? " rotate-180" : ""}`}
          />
        </button>

        {open && (
          <div className="absolute left-0 mt-0 w-[120px] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
            <div className="py-1">
              <button
                className="block w-full text-left px-4 py-1 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => {
                  openModal();
                  setFormAction("update");
                  setSectionId("pickup");
                  setPopFormId("load");
                  setIsSection(true);
                }}
              >
                Pickup
              </button>
            </div>
            <div className="py-1">
              <button
                className="block w-full text-left px-4 py-1 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => {
                  openModal();
                  setFormAction("update");
                  setSectionId("delivery");
                  setPopFormId("load");
                  setIsSection(true);
                }}
              >
                Delivery
              </button>
            </div>
            <div className="py-1">
              <button
                className="block w-full text-left px-4 py-1 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => {
                  openModal();
                  setPopFormId("load_empty_move");
                  setIsSection(false);
                }}
              >
                Empty Move
              </button>
            </div>
          </div>
        )}
      </div>
      <button
        className="bg-yellow-500 text-white px-2 py-1 rounded"
        onClick={() => {
          openModal();
          setPopFormId("route");
          setIsSection(false);
        }}
      >
        View Route
      </button>
      <button
        className="bg-orange-500 text-white bg-gray-200 px-2 py-1 rounded"
        onClick={() => {
          openModal();
          setPopFormId("drop_at_yard");
          setIsSection(false);
        }}
      >
        Drop At Yard
      </button>
      <button className="bg-pink-500 text-white px-2 py-1 rounded">
        Load / Driver Sheet
      </button>
      <button className="bg-blue-500 text-white px-2 py-1 rounded">
        Add Check Call
      </button>
      {isOpen && (
        <>
          {popFormId === "route" ? (
            <MuiModelBox isOpen={isOpen} onClose={closeModal}>
              <MapRoute />
            </MuiModelBox>
          ) : (
            <MuiModel
              isOpen={isOpen}
              onClose={closeModal}
              formId={popFormId}
              source={sourceData}
              isFormSections={{
                is: isSection,
                sectionsids: sectionId,
                formAction: formAction,
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default Stop;
